import React from 'react'
import { About, Testimonial, Footer } from '../components'
import FrequentlyAQ from '../components/FrequentlyAQ'
import Meta from '../components/common/Meta'

function AboutPage() {
  return (
    <div>
      <Meta
        title="Building Tommorrow | Rwanda Construction Support"
        description="Professional assistance for building permits, occupation permits, RDB submissions, inspections, and construction approval drawings in Rwanda."
        keywords="
          Building permit services Rwanda, Occupation permit assistance,
          RDB construction submission, Construction approval drawings,
          Building inspection services,
          Permis de construire Rwanda,
          Assistance permis d’occupation,
          Dossiers RDB construction,
          Uruhushya rwo kubaka,
          Uruhushya rwo guturamo inzu,
          Gufasha mu nyandiko za RDB,
          Construction drawings Rwanda,
          As-built drawings services,
          Technical building drawings,
          As-built drawings Kigali
          "
          />

      <nav className=' bg-contact-page justify-center pt-10 min-h-[250px] bg-cover' >
        <h1 className='font-bold text-5xl text-white uppercase text-center'>About us</h1>
        <p className='text-xl text-center text-gray-400 mt-4'>We would love to tell you more about ourselves</p>
      </nav>
      <About />
      <Testimonial />
      <FrequentlyAQ />
      <Footer />
    </div>
  )
}

export default AboutPage
